// extracted by mini-css-extract-plugin
module.exports = {"label":"TextArea_label__viV0X","input":"TextArea_input__3BLZe"};